<script lang="ts">
  import { onMount } from 'svelte';
  export let onlyOnce = true;

  let containerElement;
  let isIntersecting = false;

  onMount(() => {
    const isObserver = new IntersectionObserver(
      async intersection => {
        isIntersecting = intersection[0].isIntersecting;

        if (isIntersecting && onlyOnce) {
          isObserver.unobserve(containerElement);
        }
      },
      {
        threshold: 0,
      }
    );

    isObserver.observe(containerElement);
    return () => {
      if (containerElement instanceof Element) {
        isObserver.unobserve(containerElement);
      }
    };
  });
</script>

<div class="emptyContainer">
  {#if isIntersecting}
    <slot />
  {:else}
    <div bind:this={containerElement}>Loading...</div>
  {/if}
</div>

<style lang="scss">
  .emptyContainer {
    min-height: 50px;
  }
</style>
